import * as React from 'react';
import { useListContext } from 'react-admin';
import { List, SxProps } from '@mui/material';
import { TaskListItem } from './TaskListItem';

export const TasksIterator = ({
    showMember,
    sx,
    openEditDrawer,
}: {
    showMember?: boolean;
    sx?: SxProps;
    openEditDrawer?: (id: string | number) => void;
}) => {
    const { data, error, isPending } = useListContext();
    if (isPending || error || data.length === 0) return null;

    return (
        <List dense sx={sx}>
            {data?.map(task => (
                <TaskListItem
                    task={task}
                    showMember={showMember}
                    openEditDrawer={openEditDrawer}
                    key={task.id}
                />
            ))}
        </List>
    );
};
